import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { CreateLeadPayload } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { BaseInput, InputSize } from "shared/components";
import { RegisterTyped } from "shared/hooks";

export const BasicInfoSection = ({
  register,
  wrapperClassName,
  isTitleDisabled = false,
  cardClassName
}: {
  register: RegisterTyped<CreateLeadPayload>;
  wrapperClassName?: string;
  isTitleDisabled?: boolean;
  cardClassName?: string;
}) => {
  return (
    <SectionCard
      title="Basic information"
      wrapperClassName={wrapperClassName}
      isTitleDisabled={isTitleDisabled}
      cardClassName={cardClassName}
    >
      <div className="flex w-full gap-4">
        <div className="w-full">
          <BaseInput
            {...register("first_name")}
            id="firstName"
            labelClassName="mb-1.5"
            size={InputSize.BASE}
            label="First name"
            required
          />
        </div>

        <div className="w-full">
          <BaseInput
            {...register("last_name")}
            id="lastName"
            labelClassName="mb-1.5"
            size={InputSize.BASE}
            label="Last name"
            required
          />
        </div>
      </div>
    </SectionCard>
  );
};
